const app = Vue.createApp({
  delimiters: ["[[", "]]"],

  data() {
    return {
      isLoading: false,
      moreLoading: false,
      isError: false,
      commonConfigData: filtersConfig,
      sortByConfigData: sortByConfig,
      isMoreFilter: false,
      isAdvancedFilter: false,
      isLastPage: false,
      diamonds: [],
      advancedFilterConfigData: advancedFilterConfig,
      moreFilterConfigData: moreFilterConfig,
      filters: {
        diamondType: "white", // Default diamond type
        caratRange: [0.5, 5.0], // Default carat range
        priceRange: [500, 100000], // Default price range
        tableRange: [50, 80], // Default table % range
        depthRange: [55, 70], // Default depth % range
        ratioRange: [1, 2], // Default ratio range
        shape: "round", // Default shape value (round)
        colors: [], // Selected colors (e.g., ['D', 'E'])
        clarities: [], // Selected clarities (e.g., ['IF', 'VS1'])
        cuts: [], // Selected cuts (e.g., ['EX', 'VG'])
        certifications: [], // Selected certifications (e.g., ['GIA'])
        polish: [], // Selected polish grades (e.g., ['EX'])
        symmetry: [], // Selected symmetry grades (e.g., ['EX'])
        fluorescence: [], // Selected fluorescence levels (e.g., ['NONE']),
        growthMethod: [], // Selected growth methods (e.g., ['HPHT'])
        sortBy: 1,
      },
      activeFilters: {},
      loading: true,
      error: false,
      selectedDiamond: null,
      currentPage: 1,
      itemsPerPage: 48,
      totalDiamonds: 0,
      params: {},
      errorMessage: null,
      isGridView: true,
      isSortByView: false,
      showDetails: null,
      isFilters: false,
      groupedDiamonds: [],
      chunkSize: 4,
      diamond: !!localStorage.getItem("selectedDiamond")
        ? JSON.parse(localStorage.getItem("selectedDiamond"))
        : null,
      ring: !!localStorage.getItem("selectedRing")
        ? JSON.parse(localStorage.getItem("selectedRing"))
        : null,
      currentUrl: window.location.href,
    };
  },

  watch: {
    filters: {
      handler: function () {
        localStorage.setItem("appliedFilter", JSON.stringify(this.filters));
      },
      deep: true,
    },
    isGridView: {
      handler: function () {
        this.setDetailView();
      },
      deep: true,
    },
    diamond: {
      handler: function () {
        this.setDetailView();
      },
      deep: true,
    },
    isGridView: {
      handler: function () {
        this.setDetailView();
      },
      deep: true,
    },
    diamonds: {
      handler: function () {
        this.setGroupedDiamonds();
      },
      deep: true,
    },
    "filters.sortBy": {
      handler: function () {
        this.isSortByView = false;
        this.setDetailView();
        this.fetchDiamonds();
      },
      deep: true,
    },
    diamond: {
      handler: function () {
        if (!!this.diamond && !!this.ring) {
          this.addToCart(this.diamond, this.ring);
        }
      },
      deep: true,
    },
    ring: {
      handler: function () {
        if (!!this.diamond && !!this.ring) {
          this.addToCart(this.diamond, this.ring);
        }
      },
      deep: true,
    },
  },
  computed: {
    isDiamondSelected() {
      return !!this.diamond;
    },
    isRingSelected() {
      return !!this.ring;
    },
    isLooseDiamondPage() {
      return this.currentUrl.includes("loose-diamonds");
    },
    isEngagementRingPage() {
      return this.currentUrl.includes("engagement-rings");
    },
    totalPages() {
      return Math.ceil(this.totalDiamonds / this.itemsPerPage);
    },
  },

  async created() {
    const appliedFilter = localStorage.getItem("appliedFilter");
    if (appliedFilter) {
      this.filters = JSON.parse(appliedFilter);
    }
    this.validateShapeFromUrl();
    this.fetchDiamonds();
    // await this.checkCart();
  },

  mounted() {
    window.addEventListener("resize", this.updateChunkSize);
    this.updateChunkSize(); // Set initial chunkSize
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.updateChunkSize);
  },

  methods: {
    fixToTwoDecimal(num) {
      if (!num) {
        return;
      }
      const tempNum = Number(num);
      return tempNum.toFixed(2);
    },
    toggleFilters() {
      this.isFilters = !this.isFilters;
    },
    updateChunkSize() {
      this.screenWidth = window.innerWidth;
      if (this.screenWidth > 1200) {
        this.chunkSize = 4;
      } else if (this.screenWidth > 768) {
        this.chunkSize = 3;
      } else if (this.screenWidth > 480) {
        this.chunkSize = 2;
      } else {
        this.chunkSize = 1;
      }
    },
    setGroupedDiamonds() {
      // Group diamonds into chunks of 4
      const groups = [];
      for (let i = 0; i < this.diamonds.length; i += this.chunkSize) {
        groups.push(this.diamonds.slice(i, i + this.chunkSize));
      }
      this.groupedDiamonds = groups;
    },
    handleCaratFilterChange(changedField) {
      // Validate caratRange values
      const min = this.filters.caratRange[0];
      const max = this.filters.caratRange[1];

      if (changedField === "min") {
        // Ensure min is not greater than max
        if (min > max) {
          this.filters.caratRange[1] = min; // Automatically adjust max
        }
      } else if (changedField === "max") {
        // Ensure max is not less than min
        if (max < min) {
          this.filters.caratRange[0] = max; // Automatically adjust min
        }
      }

      // You can trigger further actions here, like API calls
      this.fetchDiamonds();
    },
    // Generate an array from min to max
    generateRange(min, max, step) {
      const range = [];
      for (let i = min; i <= max; i += step) {
        range.push(i);
      }

      return range;
    },
    handleFilterChange(isInputRange, index) {
      this.fetchDiamonds();
      this.setDetailView();
    },
    handleRangeFilterChange(isInputRange, index) {
      if (!!isInputRange) {
        this.validateInput(isInputRange, index);
      }
      this.fetchDiamonds();
      this.setDetailView();
    },
    openCertificateLink(diamond) {
      window.open(diamond?.diamond?.certificate?.pdfUrl, "_blank");
    },
    formatedPrice(price) {
      if (!!price) {
        price = price / 100;
      }
      try {
        return price.toLocaleString("en-US", {
          style: "currency",
          currency: "GBP",
        });
      } catch (error) {
        return price.toFixed(2);
      }
    },
    toggleSortByView() {
      this.isSortByView = !this.isSortByView;
    },
    validateInput(item, index) {
      const value = this.filters[item.id][index];
      if (value < item.min) {
        this.filters[item.id][index] = item.min;
      } else if (value > item.max) {
        this.filters[item.id][index] = item.max;
      }
    },
    async checkCart() {
      try {
        const response = await fetch("/cart.js", {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });

        if (response.ok) {
          const { items = [] } = await response.json();

          // Clear local storage if no items in cart
          if (items.length === 0) {
            ["selectedDiamond", "selectedRing"].forEach((key) =>
              localStorage.removeItem(key)
            );
            this.isDiamondSelected = false;
            this.isRingSelected = false;
            this.diamond = null;
            this.ring = null;
          }
        } else {
          console.error("Failed to fetch cart data:", response.statusText);
        }
      } catch (error) {
        console.error("Error checking cart:", error);
      }
    },
    async getCart(id) {
      try {
        const response = await fetch("/cart.js", {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch cart data: ${response.statusText}`);
        }

        const cartData = await response.json();

        // Ensure cartData has items
        if (!cartData.items || !cartData.items.length) {
          return null;
        }

        // Find your custom diamond's line item key
        const customDiamond = cartData.items.find((item) =>
          item.variant_title.includes(id)
        );

        if (customDiamond) {
          return customDiamond.variant_id; // Return the line item key
        } else {
          console.warn("Custom diamond not found in the cart.");
          return null;
        }
      } catch (error) {
        console.error("Error fetching cart:", error);
      }
    },
    async removeCustomDiamondFromCart(lineItemKey) {
      if (!lineItemKey) {
        console.warn("No line item key provided.");
        return;
      }

      try {
        const cartEndpoint = "/cart/change.js"; // Shopify endpoint for updating cart items
        const payload = {
          id: lineItemKey, // The line item key of the custom diamond
          quantity: 0, // Set quantity to 0 to remove it from the cart
        };

        const response = await fetch(cartEndpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          const errorData = await response.json();
          console.error("Error response:", errorData);
          throw new Error(errorData.message || "Failed to update cart.");
        }

        const updatedCart = await response.json();
      } catch (error) {
        console.error("Error removing diamond from cart:", error);
      }
    },
    async selectDiamond(diamond) {
      try {
        this.isLoading = true;
        if (!!this.diamond && !!this.ring) {
          await this.addToCart(diamond, this.ring);
        } else {
          this.diamond = diamond;
          localStorage.setItem("selectedDiamond", JSON.stringify(diamond));
          if (!this.ring) {
            setTimeout(() => {
              window.location.href = "/collections/engagement-rings";
            }, 1000);
          }
        }
      } catch (error) {
        console.error("Error selecting diamond:", error);
      } finally {
        // Ensure loading state is reset
        this.isLoading = false;
      }
    },
    async selectRing() {
      this.isLoading = true;

      if (!!this.ring && !!this.diamond) {
        await this.addToCart(this.diamond, this.ring);
      } else {
        let settingData = {};
        if (localStorage.getItem("currentPageSettingData")) {
          settingData = JSON.parse(
            localStorage.getItem("currentPageSettingData")
          );
        }
        localStorage.setItem("selectedRing", JSON.stringify(settingData));

        this.ring = settingData;

        if (!this.diamond) {
          setTimeout(() => {
            window.location.href = "/pages/loose-diamonds";
          }, 1000);
        }
      }
      this.isLoading = false;
    },
    async addCustomDiamondToCart(diamond) {
      try {
        // Step 1: Get the line item key of the custom diamond
        const lineItemKey = await this.getCart();

        // Step 2: Remove the custom diamond if it exists
        if (lineItemKey) {
          await this.removeCustomDiamondFromCart(lineItemKey);
        }

        // Step 3: Prepare the item to add to the cart
        const item = {
          id: "49919896093019", // Replace with your dummy product variant ID
          quantity: 1,
          properties: {
            diamondID: diamond.id,
            diamondName: diamond.title,
            diamondWeight: diamond.diamond?.certificate?.weight || "N/A",
            diamondColor: diamond.diamond?.certificate?.color || "N/A",
          },
        };

        // Step 4: Add the item to the cart
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(item),
        });
        if (!response.ok) {
          const errorData = await response.json();
          console.error("Error response from add to cart:", errorData);
          return false;
        }

        const cartData = await response.json();
        console.log("Cart updated successfully:", cartData);
        return true;
      } catch (error) {
        console.error("Error adding custom diamond to cart:", error);
        return false;
      }
    },
    redirectToCart() {
      // Redirect to cart page
      setTimeout(() => {
        window.location.href = "/cart";
      }, 2000);
    },

    async addToCartTemplate(item) {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(item),
      });

      if (!response.ok) {
        console.error("Failed to add item:", await response.json());
        return false;
      }

      return true;
    },
    async addToCartTemplateDiamond(diamond) {
      // Step 1: Get the line item key of the custom diamond
      const lineItemKey = await this.getCart(diamond?.diamond?.certificate?.certNumber);

      let result = null;
      let existedDataId = null;
      
      // Step 2: Remove the custom diamond if it exists
      if (lineItemKey) {
        existedDataId = lineItemKey;
      }else{
         result = await this.createCustomProductWithMetafields(diamond);
      }


      if (!!result || !!existedDataId) {
        const item = {
          id: !!existedDataId ? existedDataId : result.data.product.variants[0].id,
          quantity: 1,
        };
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(item),
        });
        if (!response.ok) {
          console.error("Failed to add item:", await response.json());
          return false;
        }
        return true;
      } else {
        return false;
      }
    },

    async addToCart(diamondData, ringData) {
      if (!!diamondData && !!ringData) {
        const success1 = await this.addToCartTemplateDiamond(diamondData);

        if (success1) {
          const success2 = await this.addToCartTemplate({
            id: ringData.variants[0].id,
            quantity: 1,
          });

          if (success2) {
            localStorage.removeItem("selectedRing");
            localStorage.removeItem("selectedDiamond");
            window.location.href = "/cart";
          }
        }
      } else {
        alert("Please select both a diamond and a ring.");
      }
    },

    diamondPayloadTitle(diamond) {
      // 0.3 Ct. D Color VVS2 Clarity Round Shape Lab Grown Diamond
      const { color, clarity, carats, shape } = diamond;
      return `${carats} ct ${color} Color ${clarity} Clarity ${shape} Shape`;
    },

    async createCustomProductWithMetafields(diamondData) {
      console.log("Creating product with metafields:", diamondData);

      const bodyData = {
        product: {
          title: this.diamondPayloadTitle(diamondData?.diamond?.certificate),
          // body_html: "<strong>Good snowboard!</strong>",
          vendor: "Mak and Co",
          images: [{ src: diamondData?.diamond?.image }],
          product_type: "Diamond",
          status: "active",
          price: diamondData?.price/100,
          variants: [
            {
              option1: `Diamond Certificate: ${diamondData?.diamond?.certificate?.certNumber}`,
              price: diamondData?.price/100,
              sku: diamondData?.diamond?.certificate?.certNumber,
            },
          ],
        },
      };
      console.log("Body data:", bodyData);

      try {
        const response = await fetch(
          `https://phplaravel-1217489-5182927.cloudwaysapps.com/api/custom-shopify-api`,
          {
            method: "POST",
            body: JSON.stringify(bodyData),
          }
        );

        const responseData = await response.json();
        console.log("Response data:", responseData);

        if (responseData.success) {
          return responseData;
        } else {
          console.error("Failed to create product:", responseData.errors);
          return null;
        }
      } catch (error) {
        console.error("Error while creating product:", error);
        return null;
      }
    },

    async addDiamondToCart(diamond) {
      try {
        const result = await this.addCustomDiamondToCart(diamond);

        if (result) {
          // Clean up localStorage
          localStorage.removeItem("selectedDiamond");
          localStorage.removeItem("selectedRing");
          setTimeout(() => {
            window.location.href = "/cart";
          }, 1000);
        }
      } catch (error) {
        console.error("Error adding diamond to cart:", error);
      }
    },

    async addRingToCart(ringData) {
      try {
        const ringitem = {
          id: ringData.id, // Replace with your dummy product variant ID
          quantity: 1,
        };

        // Step 4: Add the item to the cart
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(item),
        });

        if (!response.ok) {
          const errorData = await response.json();
          console.error("Error response from add to cart:", errorData);
          return false;
        }

        const cartData = await response.json();
        console.log("Cart updated successfully:", cartData);
      } catch (error) {
        console.error("Error:", error);
      }
    },

    setGridView(gridView = true) {
      this.isGridView = gridView;
    },

    getDescription(diamond) {
      const { shape, carats, color, clarity, cut, polish, symmetry } =
        diamond.diamond.certificate;
      // Natural Diamond D Colour  VVS2 Clarity  GD Cut
      return `${
        this.filters.diamondType == "white" ? "Natural" : "Lab Grown"
      } Diamond ${color} Colour ${clarity} Clarity ${cut} Cut `;
    },

    setDiamondType(type) {
      this.filters.diamondType = type;
      this.fetchDiamonds();
    },

    setDetailView(data, groupIndex) {
      if (!!data || !!groupIndex) {
        this.showDetails = {
          data,
          groupIndex,
        };
        return;
      }
      this.showDetails = null;
    },

    setDiamondShape(shape) {
      this.filters.shape = shape;
    },

    formatPrice(price) {
      return price.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    },

    getDiamondTitle(diamond) {
      const { shape, polish, cut, clarity, carats } =
        diamond.diamond.certificate;
      return `${carats}ct ${shape} ${cut} ${clarity} ${polish}`;
    },
    toggleMoreFilter() {
      this.isMoreFilter = !this.isMoreFilter;
    },

    toggleAdvancedFilter() {
      this.isAdvancedFilter = !this.isAdvancedFilter;
    },

    loadMoreProducts() {
      this.fetchDiamonds(true);
    },

    // filterDiamonds(diamonds) {
    //   return diamonds.filter(diamond => {
    //     // Check if image is null
    //     // if (!diamond?.diamond?.image) return false;

    //     // Check if certificate.lab is "LAB" or "IGI" (case insensitive)
    //     const lab = diamond.diamond?.certificate?.lab;
    //     if (!lab || !["GIA", "IGI"].includes(lab.toUpperCase())) return false;

    //     return true;
    //   });
    // },

    filterDiamonds(diamonds, hex) {
      return diamonds
        .filter((diamond) => {
          const lab = diamond.diamond?.certificate?.lab;
          return lab && ["GIA", "IGI"].includes(lab.toUpperCase());
        })
        .map((diamond) => ({
          ...diamond,
          price:
            !!diamond?.price && !!hex
              ? (diamond?.price + diamond?.price * customDecrypt(hex)).toFixed(
                  2
                )
              : diamond?.price,
        }));
    },

    async fetchDiamonds(isLoadMore = false) {
      this.errorMessage = null;
      this.error = false;
      if (!isLoadMore) {
        this.loading = true;
        this.diamonds = [];
        this.totalDiamonds = 0;
        this.isLastPage = false;
      } else {
        this.moreLoading = true;
      }
      this.currentPage = isLoadMore ? this.currentPage + 1 : 1;
      this.params.page = this.currentPage.toString();

      const response = await fetchDiamondList(
        this.filters,
        this.currentPage,
        this.itemsPerPage,
        this.totalDiamonds
      );
      this.loading = false;
      this.moreLoading = false;

      if (response?.data?.diamonds_by_query?.items?.length) {
        this.isLastPage =
          response?.data?.diamonds_by_query?.total_count >= this.itemsPerPage;
        this.totalDiamonds = isLoadMore
          ? Number(this.totalDiamonds) +
            Number(response?.data?.diamonds_by_query?.total_count)
          : Number(response?.data?.diamonds_by_query?.total_count);
      }

      if (response?.data?.diamonds_by_query?.items) {
        response.data.diamonds_by_query.items = this.filterDiamonds(
          response?.data?.diamonds_by_query?.items,
          response?.data1 || 0
        );
      }
      if (!!response) {
        if (
          response?.success &&
          response?.data?.diamonds_by_query?.items?.length
        ) {
          this.diamonds = isLoadMore
            ? [...this.diamonds, ...response?.data?.diamonds_by_query?.items]
            : response?.data?.diamonds_by_query?.items;
        } else {
          if (!isLoadMore) {
            this.totalDiamonds = 0;
            this.diamonds = [];
            this.errorMessage = "No diamonds found.";
            this.error = true;
            console.error("Error fetching diamonds:", response?.error);
          } else {
            this.isLastPage = true;
          }
        }
      }
    },

    async fetchDiamondDetail(diamondId) {
      this.errorMessage = null;
      this.error = true;

      try {
        const data = await fetchDiamondDetail(diamondId);
        this.selectedDiamond = data?.diamondById?.diamond;
      } catch (error) {
        this.errorMessage =
          "Failed to load diamond details. Please try again later.";
        this.error = true;
      }
    },

    updateFilter(key, value, isArray = false) {
      if (this.filters.hasOwnProperty(key)) {
        if (isArray) {
          // Toggle array values for multi-select filters
          const index = this.filters[key].indexOf(value);
          if (index === -1) {
            this.filters[key].push(value);
          } else {
            this.filters[key].splice(index, 1);
          }
        } else {
          // For single-value filters (e.g., ranges)
          this.filters[key] = value;
        }
      } else {
        console.warn(`Filter "${key}" does not exist.`);
      }
    },

    validateShapeFromUrl() {
      const url = window.location.pathname;
      const validShapes = [
        "round",
        "oval",
        "cushion",
        "pear",
        "emerald",
        "princess",
        "heart",
        "marquise",
        "asscher",
        "radiant",
      ];

      // Check if the URL matches the path
      if (url.startsWith("/pages/loose-diamonds")) {
        const shapeFromUrl = url.split("/").pop(); // Get the last segment of the URL

        if (validShapes.includes(shapeFromUrl)) {
          // If the shape exists in the URL, set the shape to that value
          this.filters.shape = shapeFromUrl;
        } else {
          // If the shape is not valid, set it to the default value 'round'
          this.filters.shape = "round";

          // Append the valid shape to the URL
          window.history.pushState({}, "", `${url}/round`);
        }
      } else {
        // If the URL doesn't match the desired path, set the default shape
        this.filters.shape = "round";
      }
    },

    /**
     * Resets all filters to their default values.
     */
    resetFilters() {
      this.filters = {
        ...this.filters,
        diamondType: "white",
        caratRange: [0.5, 5.0],
        priceRange: [500, 100000],
        tableRange: [50, 80],
        depthRange: [55, 70],
        ratioRange: [1, 2],
        colors: [],
        // shape: "round", // Default shape value (round)
        clarities: [],
        cuts: [],
        certifications: [],
        polish: [],
        symmetry: [],
        fluorescence: [],
        growthMethod: [],
        sortBy: 1,
      };
      this.params = {
        ...this.filters,
        page: this.currentPage,
        itemsPerPage: this.itemsPerPage,
      };
      this.fetchDiamonds();
    },
  },
});

app.mount("#ring-builder-app");
